import { SelectTabData, SelectTabEvent, Tab, TabList } from '@fluentui/react-components'
import { Building24Regular, Document24Regular, Organization20Regular } from '@fluentui/react-icons'
import { useCallback, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Loading } from '../Loading'
import './WorkspaceControl.scss'
import { WorkspaceDetailsPanel } from './WorkspaceDetailsPanel' // Fixed default import
import { WorkspaceEntitiesPanel } from './WorkspaceEntitiesPanel'
import { WorkspaceFilesPanel } from './WorkspaceFilesPanel'
import { useSetHeaderContext } from '@/layouts/MainLayout/HeaderContext'
import { useGetSearchParam } from '@/hooks'
import DatabricksIcon from '../ApplicationControl/DatabricksIcon'
import { isDatabricksApp } from '@/util/appTypes'
import { createRestClient } from '@/contexts/QueryProvider'
import { ErrorComponent } from '../ErrorComponent'
import { WorkspaceDatabricksPanel } from './WorkspaceDatabricksPanel'

export const WorkspaceControl = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [loading, setLoading] = useState(false)

  const tab = useGetSearchParam('tab') ?? 'details' // Default to 'details'
  const orgName = useGetSearchParam('orgName')
  const projectName = useGetSearchParam('projectName')
  const appName = useGetSearchParam('appName')
  const appKey = useGetSearchParam('appKey')
  const projectId = useGetSearchParam('projectId')

  const orgId = useGetSearchParam<number>('orgId')
  const workspaceId = useGetSearchParam<number>('subscriptionId')

  useSetHeaderContext({
    title1: appName,
    title2: projectName,
    titleUrl: appKey && projectId ? `/${appKey}/home?pid=${projectId}` : undefined,
    rightTitle: orgName ? { text: orgName, icon: Organization20Regular } : undefined,
  })

  const onTabSelect = useCallback(
    (_e: SelectTabEvent, data: SelectTabData) => {
      setLoading(true)
      searchParams.set('tab', data.value as string)
      setSearchParams(searchParams)
      setLoading(false)
    },
    [searchParams, setSearchParams]
  )

  const { getSubscriptionsApiGetOrganisationWorkspace } = createRestClient()

  const {
    data: workspace,
    isPending: workspacePending,
    isError: workspaceError,
  } = getSubscriptionsApiGetOrganisationWorkspace.useQuery(
    {
      query: { orgId, workspaceId },
    },
    {
      enabled: !!orgId && !!workspaceId,
    }
  )

  if (workspacePending) return <Loading />
  if (workspaceError) return <ErrorComponent />

  const showDatabricks = isDatabricksApp(workspace.appTypes)

  return (
    <div className="workspaces">
      <div className="container">
        {/* <Breadcrumbs /> TODO: Shows up like "Workspaces/PwC-ZA|Sibanye|Show" now. Clicking on Workspaces doesn't lead anywhere as it needs an org id */}
        <TabList selectedValue={tab} onTabSelect={onTabSelect}>
          <Tab id="details" value="details">
            Details
          </Tab>
          <Tab id="entities" value="entities" icon={<Building24Regular />}>
            Entities
          </Tab>
          <Tab id="files" value="files" icon={<Document24Regular />}>
            Files
          </Tab>
          {showDatabricks && (
            <Tab id="databricks" value="databricks" icon={<DatabricksIcon />}>
              Databricks
            </Tab>
          )}
        </TabList>
        <div style={{ padding: '20px 10px' }}>
          {loading && <Loading />}
          {tab === 'details' && <WorkspaceDetailsPanel />}
          {tab === 'entities' && <WorkspaceEntitiesPanel />}
          {!loading && tab === 'files' && <WorkspaceFilesPanel />}
          {tab === 'databricks' && <WorkspaceDatabricksPanel />}
        </div>
      </div>
    </div>
  )
}
